import { FunctionComponent } from 'react'
import { ToastContainer, useMediaQuery } from '@conexasaude/conexa-hero'
import { QueryClientProvider, QueryClient } from '@tanstack/react-query'
import Router from '@/router'
import globalStyles, { globalStylesEmotion } from './styles/globalStyles'
import { ModalProvider } from './components/Modal/contexts/ModalContext'
import { Global } from '@emotion/react'
import { useHeight } from './hooks/useHeight'
import { MobileHeader } from './components/MobileHeader'
import { BREAKPOINT_SIZES } from './styles/mixins/breakpoint-mixin'
import { RenderIf } from './components/RenderIf'
import { matchPath, useLocation } from 'react-router-dom'
import { AnalyticsProvider } from '@conexasaude/analytics'
import { useAnalyticsData } from './hooks/useAnalyticsData'

import 'animate.css'

const MEU_ARRAY_DE_ROTAS = [
  '/alterar-senha',
  '/alterar-senha/form',
  '/alterar-senha/load',
  '/alterar-senha/load/:uniqueCode/:token',
  '/alterar-senha/load/:token',
  '/suporte',
  '/senha-alterada',
]

const queryClient = new QueryClient()
const App: FunctionComponent = () => {
  const styles = globalStyles()
  const height = useHeight()
  const isMobile = useMediaQuery(BREAKPOINT_SIZES?.phone?.query)
  const { pathname } = useLocation()
  const isMatch = MEU_ARRAY_DE_ROTAS.some(path => {
    const matchedPatch = matchPath(path, {
      path: pathname,
      exact: true,
    })
    return matchedPatch
  })
  const analyticsDataSync = useAnalyticsData()

  return (
    <QueryClientProvider client={queryClient}>
      <AnalyticsProvider appDataSync={analyticsDataSync}>
        <ModalProvider>
          <ToastContainer />
          <div css={[styles.mainContainer, styles.typography]}>
            <RenderIf condition={isMobile && !isMatch}>
              <MobileHeader />
            </RenderIf>
            <Router />
          </div>
          <Global styles={globalStylesEmotion({ height })} />
        </ModalProvider>
      </AnalyticsProvider>
    </QueryClientProvider>
  )
}

export default App
